<style>
  .overflow-dialog .mat-dialog-container {
    overflow: visible !important;
  }
</style>

<!-- STANDALONE DRIVER SECTION (Draft / Newly created project)     -->

<div *ngIf="isStandaloneDriverMode">
  <h2 class="driver-dialog-title">Driver Selection</h2>

  <p class="project-label" *ngIf="data?.projectName">
    Project: <strong>{{ data.projectName }}</strong>
  </p>

  <label class="field-label">
    Driver <span class="required-star">*</span>
  </label>

  <div class="custom-dropdown">
    <div
      class="dropdown-trigger"
      [class.error-border]="driverTouched && !selectedDriver"
      (click)="toggleDropdown()">
      <span>{{ selectedDriverLabel || '-- Select Driver --' }}</span>
      <span>&#9660;</span>
    </div>

    <div class="dropdown-panel" *ngIf="isDropdownOpen">
      <div class="dropdown-item" *ngIf="isDriverLoading">Loading drivers...</div>
      <div
        class="dropdown-item"
        *ngFor="let driver of driverOptions"
        [class.selected]="selectedDriver === driver.value"
        (click)="selectDriver(driver)">
        <span>{{ driver.label }}</span>
        <small *ngIf="driver.description">{{ driver.description }}</small>
      </div>
    </div>
  </div>

  <div class="dropdown-error" *ngIf="driverTouched && !selectedDriver">
    Driver selection is required.
  </div>

  <div class="retry-link" *ngIf="!isDriverLoading && driverOptions.length === 0">
    Failed to load drivers. <a (click)="onRetryDrivers()">Retry</a>
  </div>

  <mat-form-field appearance="outline" class="full-width comment-field">
    <mat-label>Comment <span class="optional-label">(Optional)</span></mat-label>
    <textarea
      matInput
      [(ngModel)]="driverComment"
      rows="3"
      placeholder="Enter comment...">
    </textarea>
  </mat-form-field>
</div>

<div *ngIf="!isStandaloneDriverMode">

  <div *ngIf="ActivationsArray?.length>0">
    <p>The following activations can be submitted for approval:</p>
    <ul *ngFor="let activations of ActivationsArray">
      <li>{{ activations }}</li>
    </ul>
    <p>You and the project owner will be copied on the confirmation email that is sent to the assigned approver.</p>
  </div>

  <div *ngIf="noAttaActivationsArray?.length>0">
    <p>Cannot submit below activations for Approval.</p>
    <p>Add attachments to these activations before submitting for approval:</p>
    <ul *ngFor="let noAttactivations of noAttaActivationsArray">
      <li>{{ noAttactivations }}</li>
    </ul>
  </div>

  <div *ngIf="SavedActivations?.length>0">
    <p>Changes to this activation will be saved:</p>
    <ul *ngFor="let activations of SavedActivations">
      <li>{{ activations }}</li>
    </ul>
  </div>

  <!-- Change Request flow -->
  <div *ngIf="data.changeReqList?.length>0">
    <p>
      The edit you have made requires a change request to be submitted. This change will need
      to be approved by Finance in order to update the Project Activation (including any
      associated POs).
    </p>

    <ul>
      <li>{{ data.changeReqList }}</li>
    </ul>

    <mat-form-field appearance="outline" class="full-width">
      <textarea
        type="text"
        maxlength="350"
        [(ngModel)]="CRcomment"
        placeholder="Please enter a brief comment here to describe why the change is taking place."
        matInput
        style="height: 7.5rem !important">
      </textarea>
    </mat-form-field>

    <!-- CR Driver Section -->
    <ng-container *ngIf="data?.showDriverSection">

      <label class="field-label">
        Driver <span class="required-star">*</span>
      </label>

      <div class="custom-dropdown">
        <div
          class="dropdown-trigger"
          [class.error-border]="driverTouched && !selectedDriver"
          (click)="toggleDropdown()">
          <span>{{ selectedDriverLabel || '-- Select Driver --' }}</span>
          <span>&#9660;</span>
        </div>

        <div class="dropdown-panel" *ngIf="isDropdownOpen">
          <div class="dropdown-item" *ngIf="isDriverLoading">Loading drivers...</div>
          <div
            class="dropdown-item"
            *ngFor="let driver of driverOptions"
            [class.selected]="selectedDriver === driver.value"
            (click)="selectDriver(driver)">
            <span>{{ driver.label }}</span>
            <small *ngIf="driver.description">{{ driver.description }}</small>
          </div>
        </div>
      </div>

      <div class="dropdown-error" *ngIf="driverTouched && !selectedDriver">
        Driver selection is required.
      </div>

      <div class="retry-link" *ngIf="!isDriverLoading && driverOptions.length === 0">
        Failed to load drivers. <a (click)="onRetryDrivers()">Retry</a>
      </div>

      <mat-form-field appearance="outline" class="full-width comment-field">
        <mat-label>Driver Comment <span class="optional-label">(Optional)</span></mat-label>
        <textarea
          matInput
          [(ngModel)]="driverComment"
          rows="3"
          placeholder="Enter driver comment...">
        </textarea>
      </mat-form-field>

    </ng-container>
  </div>

  <div *ngIf="NewSavedActivations?.length>0">
    <p>New project activation will be saved:</p>
    <ul *ngFor="let activations of NewSavedActivations">
      <li>{{ activations }}</li>
    </ul>
  </div>

  <div>
    <p>{{ deleteMessage }}</p>
    <p>{{ data.deleteAlert }}</p>
  </div>

  <div *ngIf="siftLocked">
    <p>
      SIFT is currently locked in preparation for month end close. While SIFT is locked you cannot
      edit or create new projects. You are still able to view your projects as well as create and
      submit change requests. Reach out to your Marketing Finance partner if you have any questions.
      SIFT will be unlocked on Wednesday.
    </p>
  </div>
</div>
<div mat-dialog-actions>
  <div>
    <button
      mat-raised-button
      style="background-color: #E82C2A;"
      class="btn btn-finish btn-fill btn-success btn-wd"
      mat-dialog-close
      (click)="close()">
      Cancel
    </button>
  </div>

  <button
    style="margin-right: 0%; margin-left: auto;"
    class="btn btn-next btn-fill btn-success btn-wd"
    [disabled]="noAttaActivationsArray?.length>0 || isDriverLoading"
    (click)="onProceed()">
    {{ isStandaloneDriverMode ? 'Save' : 'Submit' }}
  </button>
</div>